import axios from 'axios';

import { SCENARIO_EMPLOYER_SETTINGS } from '../endpoints';

export type EmployerSettingsResponse = {
  claId: number;
  employerId: number;
  yearHours: number;
  nphPercentage: {
    illness: number;
    leave: number;
    festiveDays: number;
    plb: number;
  };
  nphPercentageSubstitute: {
    illness?: number;
    leave?: number;
    festiveDays?: number;
    plb?: number;
  };
};

export type PutEmployerSettingsPayload = {
  nphPercentageSubstitute: {
    illness: number | null;
    plb: number | null;
  };
};

export const getEmployerSettings = (scenarioId: number, year: number) =>
  axios.get<EmployerSettingsResponse>(SCENARIO_EMPLOYER_SETTINGS, {
    pathParams: {
      scenarioId,
      year
    }
  });

export const saveEmployerSettings = (
  payload: PutEmployerSettingsPayload,
  scenarioId,
  year
) =>
  axios.put(SCENARIO_EMPLOYER_SETTINGS, payload, {
    pathParams: {
      scenarioId,
      year
    }
  });
